var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.66667C0 1.22464 0.175595 0.800716 0.488155 0.488156C0.800716 0.175595 1.22464 0 1.66667 0H21.6667C22.1087 0 22.5326 0.175595 22.8452 0.488156C23.1577 0.800716 23.3333 1.22464 23.3333 1.66667C23.3333 2.10869 23.1577 2.53262 22.8452 2.84518C22.5326 3.15774 22.1087 3.33333 21.6667 3.33333H1.66667C1.22464 3.33333 0.800716 3.15774 0.488155 2.84518C0.175595 2.53262 0 2.10869 0 1.66667ZM0 10C0 9.55797 0.175595 9.13405 0.488155 8.82149C0.800716 8.50893 1.22464 8.33333 1.66667 8.33333H21.6667C22.1087 8.33333 22.5326 8.50893 22.8452 8.82149C23.1577 9.13405 23.3333 9.55797 23.3333 10C23.3333 10.442 23.1577 10.8659 22.8452 11.1785C22.5326 11.4911 22.1087 11.6667 21.6667 11.6667H1.66667C1.22464 11.6667 0.800716 11.4911 0.488155 11.1785C0.175595 10.8659 0 10.442 0 10ZM0 18.3333C0 17.8913 0.175595 17.4674 0.488155 17.1548C0.800716 16.8423 1.22464 16.6667 1.66667 16.6667H11.6667C12.1087 16.6667 12.5326 16.8423 12.8452 17.1548C13.1577 17.4674 13.3333 17.8913 13.3333 18.3333C13.3333 18.7754 13.1577 19.1993 12.8452 19.5118C12.5326 19.8244 12.1087 20 11.6667 20H1.66667C1.22464 20 0.800716 19.8244 0.488155 19.5118C0.175595 19.1993 0 18.7754 0 18.3333Z",
    fill: "#004E72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.2a9f524637ded8866d7606331dc388d8.svg";
export { ForwardRef as ReactComponent };